<template>
  <div class="tab-bordered">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabBordered",
  props: {
    active: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.tab-bordered {
  @include mq-down(md) {
    margin: 0 -20px;
  }
}
</style>
